module.exports = __webpack_public_path__ + "static/media/icon-exclamation-mark.75dcd461.svg";